module.exports = __webpack_public_path__ + "img/h3.4a8505a9.png";